import { ProfitAnalysisPage } from "../../_shared/ProfitAnalysisPage";

export default function SpecViewPage() {
  return <ProfitAnalysisPage paType="spec" mode="view" />;
}
